// Filename: public/cleverTapEvents.js
import wixUsers from 'wix-users';
import wixLocationFrontend from 'wix-location-frontend';
let email = '';
let wixUserId = '';
let sourcePage = wixLocationFrontend.url;
let lastEventTime;

export async function saveCleverTapEvent(eventName, eventData) {
    
    let currentEventTime = Date.now();
    try {
        if (email == '') {
            await getUserDetails();
        }
        
        if(!eventData.Email) {
            eventData.Email = email;
        }
       
        eventData.WixUserId = wixUserId;
        if (!lastEventTime || (currentEventTime - lastEventTime >= 1000)) {
            //console.log('Firing event..', eventName, eventData);
            lastEventTime = currentEventTime;
            eventData.SourcePage = sourcePage;
            $w("#clevertapComunicator").value = eventName;
            $w("#clevertapProperties").value = JSON.stringify(eventData);
        } else {
            //console.log('waiting for 1 sec..', eventName);
            setTimeout(() => {
                saveCleverTapEvent(eventName, eventData);
            }, 1500);
        }
    } catch (e) {
        console.log("CleverTatEventError1:-", e)
    }
}

export async function clevertapEvent(eventName, eventData) {
    try {
        $w("#clevertapComunicator").value = eventName;
        $w("#clevertapProperties").value = JSON.stringify(eventData);
    } catch (e) {
        console.log("CleverTatEventError1:-", e)
    }

}

async function getUserDetails() {
    //console.log('Geting Email....');
    try {
        let user = wixUsers.currentUser;
        if (user && user.loggedIn) {
            email = await user.getEmail();
            wixUserId = user.id;
        }
    } catch (e) {
        console.log("CleverTatEventError2:-", e)
    }
}